import {
  animate,
  keyframes,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AppNotificationInterface } from '../../models/app-notification.interface';
import { AppNotificationsService } from '../../services/app-notifications.service';

@Component({
  selector: 'app-notifications',
  standalone: false,
  templateUrl: './app-notifications.component.html',
  styleUrls: ['./app-notifications.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
  animations: [
    trigger('appNotificationHideShow', [
      transition(':leave', [
        animate(
          '0.4s 0s ease',
          keyframes([
            style({
              height: '*',
              opacity: 1,
              transform: 'none',
            }),
            style({
              height: '*',
              opacity: 0,
              transform: 'translateX(10px)',
            }),
            style({
              height: 0,
              opacity: 0,
              transform: 'translateX(10px)',
            }),
          ]),
        ),
      ]),
      transition(':enter', [
        animate(
          '0.4s 0s ease',
          keyframes([
            style({
              height: 0,
              opacity: 0,
              transform: 'translateX(10px)',
            }),
            style({
              height: '*',
              opacity: 0,
              transform: 'translateX(10px)',
            }),
            style({
              height: '*',
              opacity: 1,
              transform: 'none',
            }),
          ]),
        ),
      ]),
    ]),
  ],
})
export class AppNotificationsComponent implements OnDestroy, OnInit {
  private readonly _appNotificationsService = inject(AppNotificationsService);

  private _destroyed$: Subject<void> = new Subject<void>();
  notifications!: Array<AppNotificationInterface>;

  ngOnInit(): void {
    this._appNotificationsService
      .getNotifications$()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((notifications: Array<AppNotificationInterface>) => {
        this.notifications = notifications;
      });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
